import type {Skill} from './types';
export type MasteryStatus='Not checked'|'Learning'|'Needs rebuilding'|'Placed · check soon'|'Learned · review pending'|'Building retention'|'Retained';
// "Retained" is evidence from our checks, not an educational certification.
export function masteryStatus(s:Skill|undefined):MasteryStatus{
  if(!s)return 'Not checked';
  if(s.needsHelp)return 'Needs rebuilding';
  if(!s.acquired)return s.attempts?'Learning':'Not checked';
  if((s.recallDays?.length??0)>=3)return 'Retained';
  // Inferred placements are a starting guess until a fresh check confirms them.
  if(isInferredPlacement(s))return 'Placed · check soon';
  return s.retentionDays>0?'Building retention':'Learned · review pending';
}
export const prerequisiteReady=(s:Skill|undefined)=>!!s?.acquired&&!s.needsHelp;
// Placed from related answers rather than answered directly, and not yet confirmed by a review.
export const isInferredPlacement=(s:Skill|undefined)=>!!s?.acquired&&s.source==='placement'&&s.evidence!=='direct'&&s.retentionDays===0;
